import { makeStyles } from 'tss-react/mui';
import {darkGrey} from "../../../../globalStyle";

const useStyles = makeStyles()(() => ({
    root: {
        padding: "1rem 1rem 1rem 1rem",
        minHeight: "300px",
        marginRight: "1rem",
        borderRadius: "0 12px 12px 12px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "space-between",
    },
    thirdpartyTitleContainer: {
        paddingBottom: "1.5rem",
    },
    blocTitle: {
        padding: "12px 0 9px 0",
        wordBreak: "break-word",
        display: "flex",
        alignItems: "flex-start",
    },
    icon: {
      width: "20px",
      marginRight: "0.5rem",
    },
    typoContent: {
        fontSize: "12px",
        color: darkGrey,
        display: "inline",
    },
    typoContentUpper: {
        fontSize: "12px",
        color: "black",
        display: "inline",
        textTransform: "uppercase",
    },
    typoLineWrapper: {
        overflow: "hidden",
        textOverflow: "ellipsis",
        lineClamp: 1,
        boxOrient: "vertical",
        display: "-webkit-box",
        wordBreak: "break-all",
    },
    typoLabel: {
        fontSize: "12px",
        color: "black",
        display: "inline",
    },
    unmanagedThirdPartyInfoContainer: {
        backgroundColor: "#F2F3F7",
        padding: "10px 15px",
        fontSize: "12px",
        color: "#535362",
        fontWeight: 600,
        display: "flex",
        alignItems: "center",
        gap: "5px",
        borderRadius: "16px",
        marginTop: "10px"
    },
    unmanagedThirdPartyEditProfil: {
        fontWeight: 600,
        textDecoration: "underline",
        cursor: "pointer",
    },
    iconTP: {
        width: "20px",
    },
    consultTP: {
        color: "#7E7E8F",
        fontWeight: "600",
        fontSize: "12px",
    },
}));

export default useStyles;
